/* eslint-disable max-len */
import React from 'react';
import { SvgProps, IconType } from '../../types/types';

export const Genre: IconType = (props: SvgProps) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="24" cy="24" r="19" stroke="#7D7FE8" strokeWidth="2" />
      <rect x="34" y="35" width="6" height="6" fill="white" />
      <circle
        cx="24"
        cy="24"
        r="4"
        fill="#D8D9F8"
        stroke="#7D7FE8"
        strokeWidth="2"
      />
      <circle cx="24" cy="24" r="6" stroke="#B1B2F1" strokeWidth="2" />
      <path
        d="M11.9415 22.8213C11.4556 22.7738 11.02 23.1294 11.0056 23.6174C10.9501 25.5033 11.3057 27.3825 12.052 29.1231C12.7984 30.8637 13.9145 32.4168 15.3189 33.6767C15.6824 34.0028 16.2402 33.9324 16.5408 33.5476C16.8413 33.1629 16.7704 32.6098 16.4105 32.28C15.2389 31.206 14.3059 29.8932 13.677 28.4264C13.048 26.9595 12.7402 25.3786 12.77 23.7896C12.7791 23.3014 12.4274 22.8688 11.9415 22.8213Z"
        fill="#7D7FE8"
      />
      <path
        d="M36.0585 25.1787C36.5444 25.2262 36.98 24.8706 36.9944 24.3826C37.0499 22.4967 36.6943 20.6175 35.948 18.8769C35.2016 17.1363 34.0855 15.5832 32.6811 14.3233C32.3176 13.9972 31.7598 14.0676 31.4592 14.4524C31.1587 14.8371 31.2296 15.3902 31.5895 15.72C32.7611 16.794 33.6941 18.1068 34.323 19.5736C34.952 21.0405 35.2598 22.6214 35.23 24.2104C35.2209 24.6986 35.5726 25.1312 36.0585 25.1787Z"
        fill="#7D7FE8"
      />
      <path
        d="M30.2829 40.3984V33.5525C30.2829 33.2404 30.4947 32.9682 30.7972 32.8916L41.36 30.2152C41.7908 30.106 42.2092 30.4317 42.2092 30.8761V41.5839C42.2092 45.1094 39.7456 45.1633 38.4145 45.1094C35.8612 45.0061 35.606 40.9948 38.6337 40.1211C38.958 40.0276 39.2119 39.7503 39.2156 39.4128L39.2612 35.1757C39.2661 34.7221 38.835 34.3903 38.3977 34.5112L34.0215 35.7211C33.7359 35.8001 33.5339 36.0546 33.522 36.3508L33.2092 44.1021C33.2092 46.3685 29.4145 47 28.0126 45.8649C25.9164 44.1677 27.3842 41.5967 29.6053 41.1481C29.9744 41.0736 30.2829 40.775 30.2829 40.3984Z"
        fill="white"
        stroke="#7D7FE8"
        strokeWidth="2.04545"
      />
    </svg>
  );
};
